import CustomerDetailsContainer from './CustomerDetails'

const CustomerDetailsPage = ({ heading }) => (
  <>
    {heading}
    <div style={{ marginTop: 40 }}>
      <CustomerDetailsContainer />
    </div>
  </>
)

export default CustomerDetailsPage
